<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <!-- snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="4000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
         <div class="d-flex justify-end" v-if="is_admin">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2,mt-2"
        style="margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <!-- overlay -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin -->
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Smart Desk </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded clearable required v-model="ay" return-object
                        :items="academis_year_list" item-text="ay" item-id="id" label="Select Subject" outlined
                        persistent-hint  hint="Select Academic Year" @change="getSubjectByAy(ay)">
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded clearable required v-model="sel_crs" return-object
                        :items="inst_crs_list" item-text="coi_display_name" label="Select Subject" outlined
                        persistent-hint @change="clear" hint="Select Subject" multiple>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="pt-2">
                    <v-btn class="button" @click="fetch" :disabled="sel_crs.length == 0">Fetch</v-btn>
                    <!-- CRS:{{ sel_crs }}  -->
                </v-col>
            </v-row>
            <br />
            <template v-if="fetch_load == true && sel_crs.length > 0">
                <v-row dense justify="center">
                    <v-btn v-if="share_screen" class="mr-2" color="primary" @click="component = 'Share-Screen'">Share
                        Screen</v-btn>
                    <v-btn v-if="upload_document" class="mr-2" color="warning" @click="component = 'upload-doc'">Upload
                        Document</v-btn>
                    <v-btn v-if="question_bank" class="mr-2" color="success" @click.stop="showQuestion = true"
                        @click="component = 'Question'">Question Bank</v-btn>
                    <v-btn v-if="response_analysis" class="mr-2" color="secondary"
                        @click.stop="showResponseAnalysis = true" @click="component = 'Response'">Response
                        Analysis</v-btn>
                    <v-btn v-if="raised_queries" class="mr-2" color="info" @click.stop="showRaisedQueries = true"
                        @click="component = 'raised-logs'">Raised Queries</v-btn>
                    <v-btn v-if="show_students" class="mr-2" color="warning" v-bind="attrs" v-on="on"
                        @click="showAllStudent()"> Students - {{ learners.length }}</v-btn>
                    <div :class="show_all_student ? 'all-student' : ''" id="style-3">

                        <v-expand-x-transition v-for="(learner, index) in learners" :key="index" class="overflow-auto"
                            style="height: 300px;">

                            <v-card flat v-if="show_all_student" class="mx-auto mb-3 ">
                                {{ index + 1 }}){{ learner.display_name }}
                                <v-btn outlined x-small fab color="error" class="mr-2"
                                    @click="deletestudent(learner.lid)" title="logout">
                                    <v-icon>mdi-location-exit</v-icon>
                                </v-btn>


                            </v-card>
                        </v-expand-x-transition>

                        <v-btn class="mr-2" x-small v-if="show_all_student"
                            @click="deletestudent(learners.map(learner => learner.lid))" color="red lighten-2">Logout
                            All Students
                        </v-btn>


                    </div>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="12" md="12">
                        <template v-if="component != null">
                            <share-screen v-if="component == 'Share-Screen'" :sel_crs="sel_crs" />

                            <upload-doc v-if="component == 'upload-doc'" :sel_crs="sel_crs" />

                            <response-analysis v-model="showResponseAnalysis" v-if="component == 'Response'"
                                :sel_crs="sel_crs" />

                            <question v-model="showQuestion" v-if="component == 'Question'" :sel_crs="sel_crs" />
                            <raised-logs v-model="showRaisedQueries" v-if="component == 'raised-logs'"
                                :learners="this.learners" />
                        </template>
                    </v-col>
                </v-row>
            </template>
        </v-card>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Smart Desk Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/Ew0knnmuRyg?si=hl6SQiIjdvMuSnoO"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        "share-screen": () => import("./ShareScreen"),
        "upload-doc": () => import("./UploadDocument"),
        "response-analysis": () => import("./ResponseAnalysis"),
        question: () => import("./Question"),
        "raised-logs": () => import("./RaisedHandLogs"),
        Breadcrumbs
    },
    data: () => ({
        is_admin: false,
        snackbar_msg: "",
        videoDialog:false,
        color: "",
        snackbar: false,
        overlay: false,
        // extraBreadcrumbItems: [
         

        // ],
        breadcrumbClass: "breadcrumb-style1",

        ///////////////////////////////////////////////
        fetch_load: false,
        inst_crs_list: [],
        academis_year_list:[],
        ay:"",
        sel_crs: [],
        component: null,
        learners: [],
        total_selected: [],
        show_all_student: false,
        showResponseAnalysis: false,
        showQuestion: false,
        showRaisedQueries: false,

        //default values for button
        share_screen: null,
        upload_document: null,
        question_bank: null,
        response_analysis: null,
        raised_queries: null,
        show_students: null,
    }),
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        courseFilter() {
            console.log("in func ", this.sel_crs);
        },
        showAllStudent() {
            if (this.show_all_student) {
                this.show_all_student = false;
            } else {
                this.show_all_student = true;
            }
        },
        ///////////
        clear() {
            this.component = null;
            this.learners = [];
            this.fetch_load = false;

            if (this.sel_crs.length > 0) {
                for (var i = 0; i < this.sel_crs.length; i++) {
                    if (this.total_selected.length == 0) {
                        this.total_selected.push(this.sel_crs[i].coff_id);
                        return;
                    }
                    if (this.total_selected.includes(this.sel_crs[i].coff_id)) {
                        this.total_selected = [];
                        this.total_selected.push(this.sel_crs[i].coff_id);
                    } else {
                        // alert("please select same standard ");
                        this.showSnackbar("red", "Please select same standard !!!");
                        this.total_selected = [];
                        this.sel_crs = [];
                    }
                }
            }
        },

        async fetch() {
            this.learners = [];
            this.overlay = true;
            const formdata = {
                sel_crs: this.sel_crs,
            };
            try {
                const res = await axios.post("/liveClass/getLearners", formdata);
                if (res.data.flag == "YES") {
                    this.learners = res.data.learners;
                    localStorage.setItem("live-session-students", JSON.stringify(this.learners));
                    this.fetch_load = true;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },
        async init_call() {
            this.overlay = true;
            try {
                const res = await axios.post("/liveClass/getSubject");
                if (res.data.flag == "YES") {
                    this.inst_crs_list = res.data.inst_crs_list;
                    this.share_screen = res.data.share_screen;
                    this.upload_document = res.data.upload_document;
                    this.question_bank = res.data.question_bank;
                    this.response_analysis = res.data.response_analysis;
                    this.raised_queries = res.data.raised_queries;
                    this.show_students = res.data.show_students;
                    if (res.data.is_admin !== undefined) {
                this.is_admin = res.data.is_admin;
            }
                    this.academis_year_list = res.data.academis_year_list;
                    this.ay = res.data.ay;
               } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },
         async getSubjectByAy(ay) {
            this.inst_crs_list=[],
            this.overlay = true;
            const data={
                acay:ay.id
            }
            try {
                const res = await axios.post("/liveClass/getSubjectByAy",data);
                if (res.data.flag == "YES") {
                    this.inst_crs_list = res.data.inst_crs_list;
                   
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },
        deletestudent(ids) {

            if (!confirm("Are You Sure You Want To Logout This Student" + (Array.isArray(ids) ? "s" : "") + "?")) return;
            const data = {
                delete_learner: Array.isArray(ids) ? ids : [ids],
            }
            axios
                .post("/liveClass/deletestudent", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", " Logout Successfully...");

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");

                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");

                })
                .finally(() => { });
        },

    },
    mounted() {
        this.init_call();
    },
};
</script>
<style scoped>
.all-student {
    height: 350px;

    overflow-y: scroll;
    overflow-x: hidden;
}

#style-3::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(250, 141, 51, 0.3);
    background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar-thumb {
    background-color: #5cbbf6;
}
</style>
